module.exports = __webpack_public_path__ + "static/images/downloaderweima.f0028b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/downloaderweima.png
// module id = Ku2K
// module chunks = 1